var Notification = (function () {
    var config = {
        notificationContainer: ".notif-wrapper",
        notificationClose: ".notif-close-icon",
        cookieNameAttribute: "data-cookie-name",
        cookieDurationAttribute: "data-cookie-duration",
        uniqueIdAttribute: "data-unique-id",
    };

    //constructor
    function Notification() { }

    Notification.prototype.init = function () {
        var self = this;

        //notification close event
        $(config.notificationClose).on("click", function () {
            var container = $(this).parents(config.notificationContainer);
            self.handleNotificationClose(container);
        });
    };

    Notification.prototype.handleNotificationClose = function (container) {
        var self = this;

        //hide notification
        container.hide();
        if (pageVariables.IsFunctionalActive != "True") {
            return;
        }
        var cookieName = container.attr(config.cookieNameAttribute);
        var cookieDuration = container.attr(config.cookieDurationAttribute);
        var uniqueId = container.attr(config.uniqueIdAttribute);

        //get cookie
        var cookie = self.getCookie(cookieName);
        var cookieValue = [];
        if (cookie) {
            cookieValue = cookie.split(",");
        }

        //set cookie value if uniqueId is not present
        if (uniqueId && cookieValue.indexOf(uniqueId) === -1) {
            cookieValue.push(uniqueId);
        }

        //set cookie
        var cookieValueString = cookieValue.join(",");
        var currentDomain = window.location.hostname;
        var setCookieRequest = {
            name: cookieName,
            value: cookieValueString,
            days: cookieDuration,
            path: "/",
            domain: currentDomain,
            secure: true,
            sameSite: "strict",
        };
        self.setCookie(setCookieRequest);
    };

    Notification.prototype.setCookie = function (request) {
        var expires = "";
        if (request.days) {
            var date = new Date();
            date.setTime(date.getTime() + request.days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        var cookie =
            request.name +
            "=" +
            (request.value || "") +
            expires +
            "; path=" +
            (request.path || "/");

        if (request.domain) {
            cookie += "; domain=" + request.domain;
        }
        if (request.secure) {
            cookie += "; secure";
        }
        if (request.sameSite) {
            cookie += "; samesite=" + request.sameSite;
        }

        document.cookie = cookie;
    };

    Notification.prototype.getCookie = function (name) {
        var cookieArr = document.cookie.split(";");

        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");

            // Removing whitespace at the beginning of the cookie name and compare it with the given string
            if (name == cookiePair[0].trim()) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }

        // Return null if not found
        return null;
    };

    return Notification;
})();

$(document).ready(function () {
    if ($(".notif-wrapper").length === 0) {
        return;
    }
    var notification = new Notification();
    notification.init();
});
